import { useCallback, useMemo } from "react";

import { VoucherLimitType } from "@/lib/gql/__generated__/graphql";

import type { DateRange } from "@/components/ui/calendar/types/calendar-range";

import * as Shared from "../../../../../_shared";

export const useVoucherCheckInPeriodAvailable = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { voucherLimitType, cinStart, cinEnd } = viewModel;

	const shouldShowCheckInPeriodAvailableSection = useMemo(
		() => voucherLimitType.value === VoucherLimitType.StayDate,
		[voucherLimitType],
	);

	const onSetCinStartOrCinEnd = useCallback(
		(input: DateRange) => {
			onSetViewModel([
				{
					key: "cinStart",
					value: {
						isEdited: true,
						value: input.from,
					},
				},
				{
					key: "cinEnd",
					value: {
						isEdited: true,
						value: input.to,
					},
				},
			]);
		},
		[onSetViewModel],
	);
	return {
		shouldShowCheckInPeriodAvailableSection,
		cinStart,
		cinEnd,
		onSetCinStartOrCinEnd,
	};
};
